import { type FC, type PropsWithChildren } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';

import { useCustomStyles } from './AccoPageHeading.styles';

export const AccommodationSectionHeading: FC<PropsWithChildren> = ({ children }) => {
	const { isDesktop } = useBreakpoints();
	const { classes } = useCustomStyles();

	return (
		<Typography variant={isDesktop ? 'headingXl' : 'headingLg'} as="h2" className={classes.heading}>
			{children}
		</Typography>
	);
};
